import React from 'react'
import reason_check_icon from "../assets/reason_check.svg"

export default function Reason({ reason }) {
  const { title, description } = reason
  return (
    <div className="reason">
      <div className="reason_icon">
        <img src={reason_check_icon} alt="check icon"/>
      </div>
      <div className="text_container">
        <h3 className="reason_title">{title}</h3>
        <div className="text">{description}</div>
      </div>
    </div>
  )
}
